import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { base64UrlEncode } from '../../_helpers/input.helper';
import { PrimaryButton } from '../../_components/button/primary.button';
import { paymentService } from '../../_services/payment.service';
import { useNavigate, useParams } from 'react-router-dom';
import { toastr } from '../../_components/toastr/toastr';

export default function PaymentAuthenticate(params: {
    transactionId?: string,
    acsUrl?: string,
    creq?: string,
    isOpen: boolean,
    onClose(): void
}) {
    const [isFetchingAcsResponse, setIsFetchingAcsResponse] = useState<boolean>(false);
    const { userCartId } = useParams<{ userCartId: string }>();
    const navigate = useNavigate();

    const handleSubmit = () => {
        setIsFetchingAcsResponse(true);
    };

    useEffect(() => {
        // Use setTimeout to update the message after 2000 milliseconds (2 seconds)
        // const timeoutId = setTimeout(() => {
        //     setMessage('Delayed message after 2 seconds!');
        // }, 2000);

        // Cleanup function to clear the timeout if the component unmounts

        window.addEventListener('message', function (ev) {
            // console.log(ev.data, ev);
        }, false);
        // return () => clearTimeout(timeoutId);

    }, []);

    useEffect(() => {
        if (params.isOpen) {
            window.addEventListener('message', function (ev) {
                console.log(ev.data, ev);
            }, false);

            setTimeout(function () { (document.forms as any)["3dFormAuth"].submit(); }, 500);

            var _interval = setInterval(function () {
                paymentService.verifyTransaction(+(userCartId || 0))
                    .then((data) => {
                        if (data === true) {
                            toastr.success(" Payment was successful!");
                            navigate("../paymentConfirmation")
                        }
                    })
            }, 2000)
            return () => clearTimeout(_interval);
        }
    }, [params.isOpen]);

    return (
        <>
            <Dialog
                open={params.isOpen}
                PaperProps={{
                    component: 'form'
                }}
            >
                <DialogTitle>3D Authentication</DialogTitle>
                <DialogContent>
                    <form action={params.acsUrl} method="post" target="Preview" id="3dFormAuth" onSubmit={handleSubmit}>
                        <input type="hidden" name="creq" value={params.creq} />
                        <input type="hidden" name="threeDSSessionData" value={base64UrlEncode(params.transactionId)} />
                        <p>Please complete 3D secure payment.</p>
                        {/* <PrimaryButton
                                type="submit"
                                variant="save">{"Start 3D auth"}
                            </PrimaryButton> */}
                        {/* <button type="submit">go</button> */}
                    </form>

                    <Grid item xs={12}>
                        <iframe width={390} height={400} name="Preview"></iframe>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={params.onClose}>Back To Payment Form</Button>
                </DialogActions>
            </Dialog>

            {isFetchingAcsResponse &&
                <Typography>Waiting for authentication ...</Typography>
            }
        </>
    );
}